<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="نبذة-عن-الكاتب">
<h1><span dir="rtl">نبذة عن الكاتب</span></h1>
<p style="text-indent:0px;margin-right:-14px;"><span dir="rtl">أكرم محمد العماوي، مِن مواليد مدينة الخَليل الفلسطينية، حيثُ المسجد الإبراهيمي الشريف.</span></p><br/>
<p style="text-indent:00em;"><span dir="rtl">نَشأَ في أُسرةٍ محافِظَة لوالِدَين مِن قرية (المَسْمِيَّة) أصلاً، الواقِعة جنوب مدينة يافا الساحلية.</span></p><br/>
<p style="text-indent:00em;"><span dir="rtl">عاشَ الكاتب كسائِرِ أبناءِ فلسطين كافَة أحداث النزوح والشّتات، وتلَقَّى تعليمَه الأساسي في الأردن في ظِلِّ حرصٍ شديد مِن والدَيه على رسالةِ التعليم الذي تحقَّقَ بفضلِ الله لكافةِ إخوَة المؤلف وأخَواته.</span></p><br/>
<p style="text-indent:0em;"><span dir="rtl">أَكمَلَ تعليمهُ الجامعي في إحدى الجامعات الأوروبية، وحصلَ على شَهادة الماجستير في الهندسة.</span></p>
<p style="text-indent:00em;"><span dir="rtl">ومِن هواياتِه الرسم التجريدي وكِتابَةُ الشِّعر الحَديث.</span></p><br/>
<p style="text-indent:00em;"><span dir="rtl">ورِثَ الكاتب عن والدِه دوامَ التَّفكُّر في عظمَة اللهِ وقدرَتِه، وكانَ للأبِ المُلهِم الأثرُ الكبير في صقلِ شخصيتِه، فأحبَّ البَحثَ والقراءةَ في صِغَرِه، ودائماً ما أَثارَت كافة التخصصات والاكتشافات العلمية فُضولَهُ خلالَ كافة مراحِل حياتِه.</span></p>
<p style="text-indent:00em;"><span dir="rtl"><br/>
</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?0025c487